import {GetCartInfo} from "./cart";
import ShowBasket from "./showBasket";
import HideBasket from "./hideBasket";

export default function basketOpenClose() {
  jQuery(function () {
    $('.basket-open').on('click', function () {
      event.preventDefault();
      ShowBasket();
    });
    
    let checkoutButton = $('.func-checkout-btn');
    checkoutButton.on('click', function (e) {
      if ($('.amountProducts').get(0).outerText === '0') {
        ShowBasket();
      }
      else {
        window.location.href = $(e.target).data("cart-link")
      }
    });

    $('#basketMobile').on('click', function () {
      if ($('.amountProducts').get(0).outerText !== '0') {
        window.location.href = '/cart'
      }
    });

    $('.basket-close').on('click', function () {
      HideBasket();
    });

    $('.basket-overlay').on('click', function () {
      $('body').removeClass('basket-opened');
    });

    // GetCartInfo(function () {
    //   if ($("html.checkout-page, html.order-from-catalog-page").length > 0) {
    //     GetCart(true);
    //   }
    // });
    GetCartInfo();
  })
}